module.exports = __webpack_public_path__ + "img/caseai4.d62741db.png";